import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ClientCtx = createContext(null);

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [clientId, setClientIdState] = useState(localStorage.getItem("selectedClient"));

  const reload = useCallback(async () => {
    const r = await api.get("/clients");
    setClients(r.data);
    return r.data;
  }, []);

  useEffect(() => {
    if (!user) return;
    reload().then((list) => {
      if (user.role === "client") setClientIdState(user.client_id);
      else if (!list.find((c) => c.id === clientId)) setClientIdState(list[0]?.id || null);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, reload]);

  const setClientId = (id) => {
    localStorage.setItem("selectedClient", id);
    setClientIdState(id);
  };

  const client = clients.find((c) => c.id === clientId) || null;
  return <ClientCtx.Provider value={{ clients, client, clientId, setClientId, reload }}>{children}</ClientCtx.Provider>;
}

export const useClient = () => useContext(ClientCtx);
